export default "<div id=\"footer\" class=\"footer-container\">\r\n  <p>{{footerText}}</p>\r\n</div>\r\n";